module.exports = __webpack_public_path__ + "img/idea-sparkles.b685028a.png";